<script>
import { Bar } from "vue-chartjs";
import mushroom from "viettoc-api";
export default {
  props: ["thang"],
  computed: {
    monthCheck: function () {
      return Number(this.thang.replace("Tháng ", ""));
    },
  },
  extends: Bar,
  data() {
    return {
      month: "",
      labels: [],
      data: [],
      tuan1: 0,
      tuan2: 0,
      tuan3: 0,
      tuan4: 0,
    };
  },
  methods: {
    async fn_initData(monthCheck) {
      const resTuan1 =
        await mushroom.ldp_bai_viet.views.get_so_luong_bai_vietAsync({
          year: new Date().getFullYear(),
          month: monthCheck,
          minDayOfMonth: 1,
          maxDayOfMonth: 7,
        });
      if (resTuan1.result.length > 0) this.tuan1 = resTuan1.result[0].total;
      const resTuan2 =
        await mushroom.ldp_bai_viet.views.get_so_luong_bai_vietAsync({
          year: new Date().getFullYear(),
          month: monthCheck,
          minDayOfMonth: 8,
          maxDayOfMonth: 14,
        });
      if (resTuan2.result.length > 0) this.tuan2 = resTuan2.result[0].total;

      const resTuan3 =
        await mushroom.ldp_bai_viet.views.get_so_luong_bai_vietAsync({
          year: new Date().getFullYear(),
          month: monthCheck,
          minDayOfMonth: 15,
          maxDayOfMonth: 21,
        });
      if (resTuan3.result.length > 0) this.tuan3 = resTuan3.result[0].total;

      const resTuan4 =
        await mushroom.ldp_bai_viet.views.get_so_luong_bai_vietAsync({
          year: new Date().getFullYear(),
          month: monthCheck,
          minDayOfMonth: 22,
          maxDayOfMonth: 31,
        });
      if (resTuan4.result.length > 0) this.tuan4 = resTuan4.result[0].total;
      this.$emit("loadDone");
    },
    fn_getMonth() {
      for (let i = 1; i < 5; i++) {
        this.labels.push("Tuần " + i + " / " + "tháng " + this.monthCheck);
      }
    },
  },
  watch: {
    async thang(newVal, oldVal) {
      this.labels = [];
      this.tuan1 = null;
      this.tuan2 = null;
      this.tuan3 = null;
      this.tuan4 = null;
      console.log(this.monthCheck);
      this.fn_getMonth();
      await this.fn_initData(this.monthCheck);
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: "Số bài viết",
              backgroundColor: "rgba(255,99,132,0.2)",
              borderColor: "rgba(255,99,132,1)",
              borderWidth: 1,
              hoverBackgroundColor: "rgba(255,99,132,0.4)",
              hoverBorderColor: "rgba(255,99,132,1)",
              data: [this.tuan1, this.tuan2, this.tuan3, this.tuan4],
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  beginAtZero: true, // minimum value will be 0.
                },
              },
            ],
          },
        }
      );
    },
  },
  async mounted() {
    this.fn_getMonth();
    await this.fn_initData(this.monthCheck);
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: "Số bài viết",
            backgroundColor: "#51ca8a4f",
            borderColor: "#4ecf66",
            borderWidth: 1,
            hoverBackgroundColor: "#51ca8a94",
            hoverBorderColor: "#4ecf66",
            data: [this.tuan1, this.tuan2, this.tuan3, this.tuan4],
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true, // minimum value will be 0.
              },
            },
          ],
        },
      }
    );
  },
};
</script>
